const GHOST_RETURN_KEY = 'ghostLoginReturn';

/** Admin return session while impersonating — sessionStorage limits exposure vs localStorage. */
export const getGhostLoginReturn = () =>
  sessionStorage.getItem(GHOST_RETURN_KEY) || localStorage.getItem(GHOST_RETURN_KEY);

export const setGhostLoginReturn = (payload) => {
  const value = JSON.stringify(payload);
  sessionStorage.setItem(GHOST_RETURN_KEY, value);
  localStorage.removeItem(GHOST_RETURN_KEY);
};

export const clearGhostLoginReturn = () => {
  sessionStorage.removeItem(GHOST_RETURN_KEY);
  localStorage.removeItem(GHOST_RETURN_KEY);
};
